export const charnyTranslations = {
  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_sectors: 'Secteurs',
  breadcrumb_current: 'Charny',
  hero_h1: 'Couvreur à Charny — Soumission gratuite',
  hero_subtitle: "Spécialistes des toitures à Charny depuis 12 années. Maisons historiques et neuves, soumission gratuite en 2h.",
  hero_cta: "Demander ma soumission Charny",
  hero_stat_1: 'Plusieurs dizaines de mises en relation à Charny',
  hero_stat_2: 'Certifié',
  hero_stat_3: 'Spécialiste maisons historiques',

  // Connaitre le quartier
  quartier_h2: "Charny : un quartier au caractère unique",
  quartier_p1: "Charny, c'est un secteur d'arrondissement à l'histoire ferroviaire forte, marqué par la gare historique et les anciennes maisons de cheminots qui bordent les rues de la Gare et Commerciale. On y trouve un mix particulier : maisons centenaires aux toitures en bardeau ou ferblanterie traditionnelle, duplex des années 1950-70 souvent à toit plat, et nouveaux développements résidentiels près de l'autoroute 20.",
  quartier_p2: "Cette diversité demande un couvreur capable de travailler sur tous types : structures anciennes avec pontage vieillissant, toits plats en duplex, ou bardeau moderne sur maisons récentes. C'est ce mix qui rend Charny intéressant pour notre équipe, et pourquoi on a développé une expertise vraiment polyvalente sur ce secteur.",

  // Profil toitures
  profil_h2: "Les 3 types de toitures qu'on traite à Charny",
  profil_1_title: 'MAISONS HISTORIQUES (1900-1950)',
  profil_1_desc: "Centenaires aux toitures fatiguées. Souvent pontage à remplacer en partie, ventilation entretoit à mettre aux normes, parfois ferblanterie originale à restaurer avec respect du caractère.",
  profil_2_title: 'DUPLEX ET TOITS PLATS (1950-1980)',
  profil_2_desc: "Beaucoup de duplex et triplex avec toits plats en membrane élastomère. Réfections fréquentes après 25-30 ans. Soudure thermique bicouche pour étanchéité durable.",
  profil_3_title: 'DÉVELOPPEMENTS RÉCENTS (2000+)',
  profil_3_desc: "Bungalows et cottages récents près de l'autoroute 20. Bardeau architectural arrivant à mi-vie pour les plus anciens du lot. Réfection avec matériaux de même qualité.",

  // Services
  services_h2: "Tous nos services de toiture à Charny",
  service_1: "Réfection bardeau d'asphalte",
  service_2: "Réfection toit plat membrane élastomère (duplex)",
  service_3: 'Restauration toitures historiques',
  service_4: 'Réparation et infiltration urgence',
  service_5: 'Inspection préachat',
  service_6: 'Déneigement et déglaçage',

  // Prix
  prix_h2: "Prix moyens d'une toiture à Charny 2026",
  prix_table_type: 'Type de propriété',
  prix_table_price: 'Fourchette 2026',
  prix_row_1_type: 'Maison ancienne 1 000-1 400 pi²',
  prix_row_1_price: '7 500 $ – 12 000 $',
  prix_row_2_type: 'Duplex toit plat 1 000-1 400 pi²',
  prix_row_2_price: '11 000 $ – 18 000 $',
  prix_row_3_type: 'Triplex toit plat 1 500-2 000 pi²',
  prix_row_3_price: '17 000 $ – 26 000 $',
  prix_row_4_type: 'Maison récente cottage 1 800+ pi²',
  prix_row_4_price: '11 000 $ – 16 500 $',
  prix_note: "Les maisons historiques peuvent demander travaux pontage supplémentaires. Soumission précise après inspection sur place.",

  // Projets récents
  projets_h2: "Quelques projets récents à Charny",
  projet_1_title: 'Rue de la Gare',
  projet_1_desc: "Restauration ferblanterie maison centenaire, juin 2025",
  projet_2_title: 'Rue Commerciale',
  projet_2_desc: "Réfection toit plat duplex membrane élastomère bicouche, août 2025",
  projet_3_title: 'Secteur autoroute 20',
  projet_3_desc: "Réfection bardeau architectural bungalow, mai 2025",

  // Témoignage
  temoignage_quote: "J'ai hérité de la maison familiale sur la rue de la Gare, construite en 1920. La toiture en ferblanterie était dans un état lamentable, avec des sections qui s'effritaient. J'ai consulté trois couvreurs : deux ont proposé de tout remplacer par du bardeau standard. Seul notre couvreur partenaire a proposé une restauration respectueuse du caractère historique, avec remplacement des sections endommagées en ferblanterie neuve et réparation du pontage intérieur. Le résultat est magnifique, la maison a retrouvé son cachet d'antan. Chantier propre, équipe respectueuse. Ils connaissent vraiment les vieilles maisons de Charny.",
  temoignage_author: 'Marc T.',
  temoignage_rue: 'Rue de la Gare',
  temoignage_city: 'Charny',
  temoignage_detail: "Restauration toiture maison 1920, septembre 2025",

  // Zones proches
  zones_h2: 'On dessert aussi les secteurs voisins',
  zone_saint_romuald: 'Saint-Romuald',
  zone_saint_nicolas: 'Saint-Nicolas',
  zone_st_jean: 'Saint-Jean-Chrysostome',
  zone_levis: 'Lévis centre',

  // CTA Final
  cta_h2: "Votre toiture à Charny, peu importe son âge",
  cta_subtitle: 'Soumission gratuite en 2h, expertise maisons anciennes et neuves.',
  cta_button: "Demander ma soumission",
  cta_phone: '418-476-9950',

  // Shared
  phone_number: '418-476-9950',
};

export default charnyTranslations;